// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Vue from 'vue/dist/vue.common.js'
import ElementUI from 'element-ui'
import VueStorage from 'vue-ls'
// import VueLocalStorage from 'vue-localstorage'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App'
import router from './router'
import config from './config'
import axios from 'axios'
import 'babel-polyfill'

Vue.use(ElementUI)
Vue.use(VueStorage)

Vue.config.productionTip = false
Vue.prototype.API = config.API_URL
Vue.prototype.$messagesuccess  = function(msg) {
    ElementUI.Message({
          showClose: true,
          message: msg,
          type: 'success'
     });
}
Vue.prototype.$messagewarning = function(msg) {
    ElementUI.Message({
          showClose: true,
          message: msg,
          type: 'warning'
     });
}
Vue.prototype.$messageerror = function(msg) {
    ElementUI.Message({
          showClose: true,
          message: msg,
          type: 'error'
     });
}
Vue.prototype.$message = function(msg) {
    ElementUI.Message({
          showClose: true,
          message: msg
     });
}

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})
/*
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
*/



// WEBPACK FOOTER //
// ./src/main.js